/* eslint-disable indent */
const {
  addTabsInCode,
  isNotEquivalent,
} = require('../base-live-demo-component/utils');
const {
  defaultAdvancedColorsOptions,
  defaultAdvancedTextOptions,
  defaultInitializationOptions,
} = require('./componentProps');
const { getFrontSnippetPlaceholder } = require('./utils');
const { getValueOrDefault, processCustomColors } = require('../utils/utils');
const { CountryOfOperationItems, countryShouldAcceptInteger } = require('../utils/constants');

const componentCodeFront = (formData, i18n) => {
  try {
    const payerInfo = formData.payerInfo ? JSON.parse(formData.payerInfo) : {};
    const payerInfoHasIdentificationProps = !!Object.values(payerInfo.identification).filter(el => el).length;
    const payerInfoHasAddressProps = !!Object.values(payerInfo.address).filter(el => el).length;
    const unitPriceShouldAcceptInteger = countryShouldAcceptInteger(formData.publicKey);

    return [
      {
        code: `
        <html>
        <head>
          <script src="https://sdk.mercadopago.com/js/v2">
          </script>
        </head>
        <body>
          <div id="paymentBrick_container">
          </div>
          <script>

          const mp = new MercadoPago('YOUR_PUBLIC_KEY', {
            locale: '${CountryOfOperationItems.getFormatedLanguageByCountry(formData.publicKey, formData.language)}'
          });

          const bricksBuilder = mp.bricks();

            const renderPaymentBrick = async (bricksBuilder) => {
              const settings = {
                initialization: {
                  /*
                  ${
                    unitPriceShouldAcceptInteger
                    ? i18n.gettext('"amount" es el monto total a pagar por todos los medios de pago con excepción de la Cuenta de Mercado Pago y Cuotas sin tarjeta de crédito, las cuales tienen su valor de procesamiento determinado en el backend a través del "preferenceId"')
                    : i18n.gettext('"amount" es el monto total a pagar por todos los medios de pago con excepción de la Cuenta de Mercado Pago y Cuotas sin tarjeta de crédito, las cuales tienen su valor de procesamiento determinado en el backend a través del "preferenceId". Debe ser un número entero.')
                    }
                  }
                  */
                  amount: ${formData.amount || ''},
                  preferenceId: "<PREFERENCE_ID>",
                  payer: {
                    firstName: "${getValueOrDefault(payerInfo.firstName, defaultInitializationOptions.firstName)}",
                    lastName: "${getValueOrDefault(payerInfo.lastName, defaultInitializationOptions.lastName)}",
                    ${
                      payerInfoHasIdentificationProps
                        ? `
                    identification: {
                      ${
                        payerInfo.identification.type
                          ? `
                        type: "${payerInfo.identification.type}",
                      `
                          : ''
                      }
                      ${
                        payerInfo.identification.number
                          ? `
                        number: "${payerInfo.identification.number}"
                      `
                          : ''
                      }
                    }
                    `
                        : ''
                    }
                    email: "${
                      payerInfo.email !== ''
                        ? payerInfo.email
                        : defaultInitializationOptions.email
                    }",


                    ${
                      payerInfoHasAddressProps
                        ? `
                    address: {
                      ${
                        payerInfo.address.zipCode
                          ? `
                        zipCode: "${payerInfo.address.zipCode}",
                      `
                          : ''
                      }
                      ${
                        payerInfo.address.federalUnit
                          ? `
                        federalUnit: "${payerInfo.address.federalUnit}",
                      `
                          : ''
                      }
                      ${
                        payerInfo.address.city
                          ? `
                        city: "${payerInfo.address.city}",
                      `
                          : ''
                      }
                      ${
                        payerInfo.address.neighborhood
                          ? `
                        neighborhood: "${payerInfo.address.neighborhood}",
                      `
                          : ''
                      }
                      ${
                        payerInfo.address.streetName
                          ? `
                        streetName: "${payerInfo.address.streetName}",
                      `
                          : ''
                      }
                      ${
                        payerInfo.address.streetNumber
                          ? `
                        streetNumber: "${payerInfo.address.streetNumber}",
                      `
                          : ''
                      }
                      ${
                        payerInfo.address.complement
                          ? `
                        complement: "${payerInfo.address.complement}",
                      `
                          : ''
                      }
                    }
                    `
                    : ''
                    }
                  },
                },
                customization: {
                  visual: {
                    ${!formData.showTitle ? 'hideFormTitle: true,' : ''}
                    ${!formData.showPaymentButton ? 'hidePaymentButton: true,' : ''}
                    style: {
                      theme: "${formData.theme || 'theme'}",
                      ${processCustomColors(formData.customColors, defaultAdvancedColorsOptions)}

                    ${
                      formData.customTexts
                      !== JSON.stringify(defaultAdvancedTextOptions, null, 2)
                        ? `texts: {
                              ${addTabsInCode(
                                JSON.stringify(
                                  isNotEquivalent(
                                    JSON.parse(formData.customTexts),
                                    defaultAdvancedTextOptions,
                                  ),
                                  null,
                                  2,
                                ).slice(1, -1),
                                11,
                              ).replace(/"(\w+)"\s*:/g, '$1:')}`
                        : ''
                    }
                   },
                  },
                  paymentMethods: {
                    ${
                      formData.paymentMethod
                      .map((method, index) => addTabsInCode(`${method}: "all"`, index ? 10 : 0))
                      .join(',\n')
                    },
                    ${formData.installments ? `maxInstallments: ${formData.installments}` : ''}
                  },
                },
                callbacks: {
                  onReady: () => {
                    /*
                     ${i18n.gettext('Callback llamado cuando el Brick está listo.')}
                     ${i18n.gettext('Aquí puede ocultar cargamentos de su sitio, por ejemplo.')}
                    */
                  },
                  onSubmit: ({ selectedPaymentMethod, formData }) => {
                    // ${i18n.gettext('callback llamado al hacer clic en el botón de envío de datos')}
                    return new Promise((resolve, reject) => {
                      fetch("/process_payment", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify(formData),
                      })
                        .then((response) => response.json())
                        .then((response) => {
                          // ${i18n.gettext('recibir el resultado del pago')}
                          resolve();
                        })
                        .catch((error) => {
                          // ${i18n.gettext('manejar la respuesta de error al intentar crear el pago')}
                          reject();
                        });
                    });
                  },
                  onError: (error) => {
                    // ${i18n.gettext('callback llamado para todos los casos de error de Brick')}
                    console.error(error);
                  },
                },
              };
              window.paymentBrickController = await bricksBuilder.create(
                "payment",
                "paymentBrick_container",
                settings
              );
            };
            renderPaymentBrick(bricksBuilder);

          </script>
        </body>
        </html>
    `.replace(/^\s*[\r\n]/gm, ''),
        type: 'html',
        name: 'html',
      },
    ];
  } catch (e) {
    console.log('error', e);
    return [{
    code: getFrontSnippetPlaceholder(formData, i18n).replace(/^\s*[\r\n]/gm, ''),
    type: 'html',
    name: 'html' }];
  }
};

module.exports = componentCodeFront;
